import { GridFilterInputValue, GridFilterItem, GridFilterOperator } from "@mui/x-data-grid";

const doesNotContain: GridFilterOperator[] = [
  {
    label: 'Does Not Contain',
    value: 'doesNotContain',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }

      return (params): boolean => {
        return !String(params.value).toLowerCase().includes(String(filterItem.value).toLowerCase());
      };
    },
    InputComponent: GridFilterInputValue,
  },
];

const positionFilters: GridFilterOperator[] = [
  {
    label: 'Is Not Position',
    value: 'isNotPosition',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator || !String(filterItem.field).includes('HIDE')) {
        return null;
      }

      return (params): boolean => {
        const index = Number(String(filterItem.field).replace('HIDE', ''));
        return !params?.row?.lineupInfo?.[index]?.position.toLowerCase().includes(String(filterItem.value).toLowerCase());
      };
    },
    InputComponent: GridFilterInputValue,
  },
  {
    label: 'Is Position',
    value: 'isPosition',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator || !String(filterItem.field).includes('HIDE')) {
        return null;
      }

      return (params): boolean => {
        const index = Number(String(filterItem.field).replace('HIDE', ''));
        return params?.row?.lineupInfo?.[index]?.position.toLowerCase().includes(String(filterItem.value).toLowerCase());
      };
    },
    InputComponent: GridFilterInputValue,
  },
];

export { doesNotContain, positionFilters }